

export function isValidEmail(str) {
    return (str && /([a-zA-Z0-9\_\.\-]+)\@([a-zA-Z0-9]+)([\.])([a-zA-Z0-9\.]+)/g.test(str));
}
